<template>
  <v-sheet :class="mobile ? 'mx-4' : 'mx-15'" class="mb-15">
    <h1 class="sentence-case text-primary mb-5">
      {{ t(`routes.${name}`) }}
    </h1>
    <BillingNotificationBanner class="mb-5" />
    <ChurnedCustomerBanner class="mb-5" />
    <slot />
  </v-sheet>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useDisplay } from "vuetify";

const { t } = useI18n();

defineProps<{ name: string }>();
const { mobile } = useDisplay();
</script>
